import { render, staticRenderFns } from "./AddressListLeft.vue?vue&type=template&id=172d9918&scoped=true"
import script from "./AddressListLeft.vue?vue&type=script&lang=js"
export * from "./AddressListLeft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172d9918",
  null
  
)

export default component.exports